import { Component, EventEmitter, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TicketStore } from "@app/services/store/ticket-store";
import { ResourceAvailabilityStore } from "@app/services/store/resource-availability-store";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-server-status-dialog",
  templateUrl: "./server-status-dialog.component.html",
  styleUrls: ["./server-status-dialog.component.css"],
  imports: [MatButton, TranslatePipe]
})
export class ServerStatusDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ServerStatusDialogComponent>>(MatDialogRef);
  ticketStore = inject(TicketStore);
  resourceAvailabilityStore = inject(ResourceAvailabilityStore);
  data = inject(MAT_DIALOG_DATA);

  public onRetry = new EventEmitter<any>();
  public onLoading = new EventEmitter<boolean>();
  public loading = false;

  ngOnInit() {
    this.onLoading.subscribe((value: boolean) => {
      this.loading = value;
    });
  }

  retry() {
    this.onRetry.emit({});
  }
}
